/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails
     */
    status_set_date?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'status_set_date': json['status_set_date'] == null ? undefined : json['status_set_date'],
        'status_set_reason': json['status_set_reason'] == null ? undefined : json['status_set_reason'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_set_date': value['status_set_date'],
        'status_set_reason': value['status_set_reason'],
    };
}

